import React from 'react'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowLuxPlusNonMemberPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import Caption from 'components/Luxkit/Typography/Caption'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'

interface MappedProps {
  isLuxPlusEnabled: boolean;
}

interface Props extends MappedProps {
  totalPrice: number;
  totalMemberPrice: number;
  isFromPrice: boolean;
  ticketUnitLabel: string;
  isLuxPlusOffer: boolean;
  size?: 'S' | 'L' | 'M';
  nonMemberPriceSize?: 'L' | 'M';
}

function ExperienceTilePrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    isFromPrice,
    ticketUnitLabel,
    isLuxPlusOffer,
    isLuxPlusEnabled,
    size = 'S',
    nonMemberPriceSize = 'M',
  } = props

  if (isLuxPlusOffer && isLuxPlusEnabled) {
    return (
      <>
        {isFromPrice && <Caption
          as="span"
          colour="neutral-two"
          weight="normal"
          format="propercase"
          variant="large"
        >
          From
        </Caption>}
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size={size}
          memberPrice={totalMemberPrice}
          saleUnit="total"
        />
        <PriceRowLuxPlusNonMemberPrice
          size={nonMemberPriceSize}
          nonMemberPrice={totalPrice}
        />
      </>
    )
  }

  return (
    <>
      {isFromPrice && <PriceRowPriceCaption>From</PriceRowPriceCaption>}
      <PriceRowPrice
        size={size}
        price={totalPrice}
        saleUnit={isFromPrice ? ticketUnitLabel : 'total'}
      />
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isLuxPlusEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(ExperienceTilePrices)
